import React from 'react'

import { GridItem } from '@thg-commerce/gravity-system'
import {
  BundleCategory,
  MAX_QUANTITY_SELECTION,
} from '@thg-commerce/widget-build-your-own-bundle'

import { BundleProductCard } from './BundleProductCard'
import { BundleProduct } from './ResponsiveBuildYourOwnBundleProducts'
import { StyledGrid } from './styles'

interface ProductCategoryContentProps {
  numberOfProductsInSelectedCategory: number
  productCategory: BundleCategory
  enableQuantitySelector?: boolean
  selectedBundleProducts: BundleProduct[]
  setSelectedBundleProducts: (
    callback: (currentProducts: BundleProduct[]) => BundleProduct[],
  ) => void
  availableBundleQuantitySelection: number
}

export const ProductCategoryContent = (props: ProductCategoryContentProps) => {
  return (
    <StyledGrid>
      {props.productCategory.productBlocks?.map((product, index) => {
        return (
          <GridItem colSpan={[6, 4, 3, 3]} key={`${index}-${product.title}`}>
            <BundleProductCard
              key={`${index}-${product.title}`}
              product={product}
              numberOfProductsInSelectedCategory={
                props.numberOfProductsInSelectedCategory
              }
              categoryId={props.productCategory.id}
              setSelectedBundleProducts={props.setSelectedBundleProducts}
              selectedBundleProducts={props.selectedBundleProducts}
              maxProductsPerCategory={
                props.productCategory.maxProducts || MAX_QUANTITY_SELECTION
              }
              enableQuantitySelector={props.enableQuantitySelector}
              availableBundleQuantitySelection={
                props.availableBundleQuantitySelection
              }
            />
          </GridItem>
        )
      })}
    </StyledGrid>
  )
}
